/**
 * LoadingSpinner Component
 *
 * Reusable loading state component with spinner animation.
 */

import React from "react";
import { loadingStyles, spinnerKeyframes } from "../styles";

const LoadingSpinner = ({ message = "Loading..." }) => (
  <div style={loadingStyles.container}>
    <div style={loadingStyles.spinner} />
    <span style={loadingStyles.text}>{message}</span>
    <style>{spinnerKeyframes}</style>
  </div>
);

export default LoadingSpinner;
